// import { MDBBtn, MDBCard, MDBCardBody, MDBContainer, MDBIcon, MDBTypography } from "mdb-react-ui-kit";
// import DoubleClickDialog from "../../api/common/components/clickDialogue";
import "./ChatComponent.css"; // Import the CSS file for styling

// import ResponseComponent from "./ResponseComponent";
import { Typography, Box, CircularProgress, Card, CardContent } from "@mui/material";
import AssistantSharpIcon from "@mui/icons-material/AssistantSharp";
import TextSizeContext from "../../api/common/components/TextSizeContext";


  interface Props {
    chatSegment: string;
    handleLike?: (index: number) => void;
    handleDislike?: (index: number) => void;
    likes?: ("like" | "dislike" | null)[];
    isLoading: boolean;
  }
  
  export default function SegmentOutput({chatSegment, handleLike, handleDislike, likes, isLoading }:Props){
    function extractContent(htmlString:string) {
        // Extract paragraph content using regex
        const paragraphMatch = htmlString.match(/<p>([\s\S]*?)<\/p>/);
        const paragraphContent = paragraphMatch ? paragraphMatch[1] : "";
      
        // Extract image URLs using regex
        const imageUrls = [];
        const imgRegex = /<img src="(.*?)"[^>]+>/g;
        let imgMatch;
        while ((imgMatch = imgRegex.exec(htmlString)) !== null) {
          imageUrls.push(imgMatch[1]);
        }
      
        return { paragraphContent, imageUrls };
      }
      
      const { paragraphContent, imageUrls } = extractContent(chatSegment);

    return (
      <>
      <div>
<Card>
    <Typography variant="h5" gutterBottom>
    Segmentation and ABC(DE) Assessment
  </Typography>
                  <CardContent className="bot-response">
                    {/* <DoubleClickDialog /> */}
 <AssistantSharpIcon />{" "}
  <TextSizeContext context={paragraphContent}></TextSizeContext>
  </CardContent>
</Card>
  {imageUrls.map((url, index) => (
    <Box
      key={index}
      sx={{
        display: "flex",
        flexDirection: "column",
        mb: 2,
        boxShadow: 3,
        borderRadius: 1,
        overflow: "hidden",
      }}
    >
      <img
        src={url}
        alt={`Image ${index}`}
        style={{ width: "100%", height: "auto" }}
      />
    </Box>
  ))}

  {isLoading && (
    <Typography variant="body2" color="info.main">
      <strong>Analyser: </strong>...
    </Typography>
  )}
      </div>
 </>
  )};

